import { missionDurations, type FieldMissionHeader } from '@groupe-reca/contracts'

// Durée de la SORTIE pour la carte Mission, calculée avec la règle partagée des contrats. Le temps de travail d'une
// résidence vient du moteur de détection (`Focus.observedMs`), jamais d'ici.

/**
 * Durée active de la sortie (écoulé moins pauses). Le serveur compte la pause en cours dans `pausedSeconds` jusqu'à
 * l'instant de la lecture : pendant une pause, n'appeler qu'avec l'heure de cette lecture (aucun défilement).
 */
export function missionActiveSeconds(
  mission: Pick<FieldMissionHeader, 'startedAt' | 'endedAt' | 'pausedSeconds' | 'startEngineHours' | 'endEngineHours'>,
  now: Date,
): number {
  return missionDurations({
    startedAt: mission.startedAt,
    endedAt: mission.endedAt,
    pausedSeconds: mission.pausedSeconds,
    startEngineHours: mission.startEngineHours,
    endEngineHours: mission.endEngineHours,
    now,
  }).activeSeconds
}
